import { render, staticRenderFns } from "./TipoProduto.vue?vue&type=template&id=d62b3766&scoped=true&"
import script from "./TipoProduto.vue?vue&type=script&lang=js&"
export * from "./TipoProduto.vue?vue&type=script&lang=js&"
import style0 from "./TipoProduto.vue?vue&type=style&index=0&id=d62b3766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62b3766",
  null
  
)

export default component.exports